import { LayoutDashboard, Users } from 'lucide-react';

const menuItems = [
  { label: 'Dashboard', icon: LayoutDashboard },
  { label: 'Business List', icon: Users },
];

function Sidebar({ activeView, onSelectView }) {
  return (
    <aside className="flex flex-col gap-4 border-b border-[#ece6df] bg-white px-4 py-5 lg:gap-6 lg:border-b-0 lg:border-r lg:px-4 lg:py-7">
      <div className="border-b border-[#f2ede7] px-3 pb-4 pt-1 lg:pb-6 lg:pt-2">
        <h1 className="m-0 text-[#111111]">e-Portal</h1>
      </div>

      <nav className="flex gap-2 overflow-x-auto pb-1 lg:grid lg:overflow-visible lg:pb-0">
        {menuItems.map(({ label, icon: Icon }) => (
          <button
            className={`flex min-w-fit items-center gap-3 rounded-[14px] border-0 px-3 py-3 text-left font-inherit whitespace-nowrap transition lg:w-full lg:px-3 lg:py-3.5 ${
              activeView === label
                ? 'bg-[#f4efe9] text-[#111111]'
                : 'bg-transparent text-[#111111] hover:bg-[#faf7f3] hover:text-[#111111]'
            }`}
            key={label}
            type="button"
            onClick={() => onSelectView(label)}
          >
            <Icon className="h-[18px] w-[18px] shrink-0 text-[#6f6258]" aria-hidden="true" />
            <span>{label}</span>
          </button>
        ))}
      </nav>
    </aside>
  );
}

export default Sidebar;
